import { AlertProps } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { BaseAlert } from './base';

export const InfoAlert = (props: AlertProps) => {
	return <BaseAlert icon={<IconInfoCircle />} variant="filled" bg="green.2" {...props} />;
};
